'use strict';
import personSlideshow from './person-slideshow';
var SearchView = require('../../common/views/search-view');

module.exports = function () {

    var searchView = new SearchView();

    personSlideshow();

};
